import React, { useEffect, useState } from "react"
import { Drawer, Form, Row, Col ,Button, Space, Typography } from "antd"
import { MyInput, MySelect } from "../../Forms"
import { clientcityName, countryName } from "../../../shared";

const { Title } = Typography;

const AddClient = ({visible, onClose, edititem}) => {
  
    const [form] = Form.useForm()
    const [ loading, setLoading ] = useState(false)  
  
    useEffect(() => {
        if (visible && edititem) {
            
        } else {
            form.resetFields();
        }
    }, [visible, edititem])

    const closeDrawer= ()=>{
     
        form.resetFields()
        onClose()
    }

  return (
    <Drawer
        title={edititem?'Edit client':'Add new client'}
        onClose={closeDrawer}
        className="drawer"
        open={visible}
        width={600}
        footer={
            <Space className="w-100 right">
                <Button 
                    onClick={closeDrawer}
                    className="btncancel"
                >
                    Cancel
                </Button>
                <Button  
                    block
                    className='btnsave bg-brand'
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    onClick={()=> form.submit()}
                >
                    {edititem? 'Update' : 'Save'}
                </Button>
            </Space>
        }
    >
        <Form
            form={form}
            layout="vertical"
            initialValues={true}
            // onFinish={onFinish}
        >
            <Row gutter={16}>
                <Col span={24}>
                    <Title level={5} className="mb-3 mt-0">CLIENT DETAILS</Title>
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <MyInput
                        label= 'First Name'
                        name="firstname" 
                        size={'large'}
                        placeholder={'e.g William'}
                        required
                        message='Please enter first name'
                        value={form.getFieldValue("firstname") || ''}
                    />
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <MyInput
                        label= 'Last Name'
                        name="lastname" 
                        size={'large'}
                        placeholder={'e.g John'}
                        required
                        message='Please enter last name'
                        value={form.getFieldValue("lastname") || ''}
                    />
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <MyInput
                        label= 'Organization Name'
                        name="organizationname" 
                        size={'large'}
                        placeholder={'e.g MZ Enterprise'}
                        required
                        message='Please enter organization name'
                        value={form.getFieldValue("organizationname") || ''}
                    />
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <MyInput
                        label= 'Phone Number'
                        name="phoneNo" 
                        size={'large'}
                        type='number'
                        placeholder={'+234 | '}
                        required
                        message='Please enter phone number'
                        value={form.getFieldValue("phoneNo") || ''}
                    />
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyInput
                        label= 'Email Address'
                        name="email" 
                        size={'large'}
                        type='email'
                        placeholder={'e.g abc@gmail.com'}
                        required
                        message='Please enter email address'
                        value={form.getFieldValue("email") || ''}
                    />
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <MySelect
                        label= 'City'
                        name="city" 
                        size={'large'}
                        value={form.getFieldValue("city") || ''}
                        options={clientcityName}
                    />
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <Space className="w-100 space-cs">
                        <MyInput
                            label={"Account Number"}
                            name="accountnumber"
                            size="large"
                            type="number"
                            className="w-100"
                            required
                            message={()=>{}}
                            value={form.getFieldValue("accountnumber") || ""}
                        />
                        <Button className="pad-x fs-13 border-gray text-black h-40 margintop-5">
                            Generate
                        </Button>
                    </Space>
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                    <MyInput
                        label= 'Password'
                        name="password" 
                        size={'large'}
                        type={'password'}
                        required
                        message='Please enter password'
                        value={form.getFieldValue("password") || ''}
                    />
                </Col>
                <Col lg={{span: 12}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyInput
                        label= 'Commercial Registration Number *'
                        name="regnumber" 
                        size={'large'}
                        placeholder={'e.g RC123456'}
                        required
                        message='Please enter commercial registration number'
                        value={form.getFieldValue("regnumber") || ''}
                    />
                </Col>
            </Row>
        </Form>
    </Drawer>
  )
}

export {AddClient}